import { useOAuthStore } from '@/features/auth/store';
// the store module only: the feature barrel also carries the flow's dialogs,
// and the sign-out one imports the logout routine.
import { useFlowStore } from '@/features/flow/store';

import { useTradingSessionStore } from './store';

/**
 * Whether the app knows yet who (if anyone) is signed in.
 *
 * Both stores boot in a "not read yet" state that the UI used to render as if
 * it were the answer: the mode pill said "Demo" and the account button said
 * "Sign in" for the few hundred milliseconds before the first status read and
 * app-token exchange landed, then swapped to "Live" and the user's name.
 * Anything that describes the signed-in state should stay blank until this is
 * true.
 *
 * A social identity also has to know which flow (V1 custodial or V2 browser
 * wallet) it is in, or the header would describe the wrong one first. Without
 * a social identity the flow is decided synchronously and never waited for.
 */
export function useSessionResolved(): boolean {
    const statusResolved = useTradingSessionStore((s) => s.hasResolved);
    const profileResolved = useOAuthStore((s) => s.me !== null);
    const hasSocialIdentity = useOAuthStore(
        (s) => s.me?.authenticated === true,
    );
    const flowResolved = useFlowStore((s) => s.active !== null);
    return (
        statusResolved &&
        profileResolved &&
        (!hasSocialIdentity || flowResolved)
    );
}
